export function routeParamsWithKeysNulled(routeParams = {}, keys = []) {
  let next = { ...routeParams };

  for (let key of keys) {
    next[key] = null;
  }

  return next;
}
